const templates = [
  {
    id: "wishlist-link",
    data: "wishlist",
    template: `
      <a href="{{ wishlist.url }}" class="wk-link wk-link--{{ wishlist.state }}" title="{{ locale.view_wishlist }}">
        <div class="wk-icon wk-link__icon">{% include "wishlist-icon" %}</div>
        <span class="wk-link__label">{{ locale.wishlist }}</span>
        <span class="wk-link__count">{{ wishlist.item_count }}</span>
      </a>
    `,
  },
  {
    id: "wishlist-count",
    data: "wishlist",
    template: `
      <span class="wishlist-count"></span>
    `,
    events: {
      "render .wishlist-count": (target) => {
        const itemCount = WishlistKing.toolkit.collection.items[0].products.length
        if(itemCount == 0) {
          target.textContent = WishlistKing.toolkit.theme.locale.wishlist_empty_note
        } else if (itemCount == 1) {
          target.textContent = `${WishlistKing.toolkit.theme.locale.you_have} ${itemCount} ${WishlistKing.toolkit.theme.locale.number_of_product}`
        } else if (itemCount > 1) {
          target.textContent = `${WishlistKing.toolkit.theme.locale.you_have} ${itemCount} ${WishlistKing.toolkit.theme.locale.number_of_products}`
        }
      },
    },
  },
  {
    id: "wishlist-button",
    data: "product",
    events: {
      "click button[data-wk-add-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        const variantInput = document.querySelector("form *[name='id']");
        const variantId = variantInput ? variantInput.value : undefined;

        WishlistKing.toolkit.addProduct(
          event.currentTarget.getAttribute("data-wk-add-product"),
          variantId
        );
      },
      "click button[data-wk-remove-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeProduct(
          event.currentTarget.getAttribute("data-wk-remove-product")
        );
      },
      "click button[data-wk-remove-item]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeItem(
          event.currentTarget.getAttribute("data-wk-remove-item")
        );
      },
    },
    template: `
      {% if product.in_wishlist %}
        {% assign btn_text = locale.in_wishlist %}
        {% assign btn_title = locale.remove_from_wishlist %}
        {% assign btn_action = 'remove' %}
      {% else %}
        {% assign btn_text = locale.add_to_wishlist %}
        {% assign btn_title = locale.add_to_wishlist %}
        {% assign btn_action = 'add' %}
      {% endif %}
      {% assign scope = "product" %}
      {% assign targetId = product.id %}
      {% assign icon_name = "wishlist-icon" %}
      {% if itemId %}
      {% assign scope = "item" %}
      {% assign targetId = itemId %}
      {% assign icon_name = "wishlist-icon" %}
      {% endif %}
      <button type="button" class="wk-button wk-button--{{ btn_action }} {{ addClass }}" title="{{ btn_title }}" data-wk-{{ btn_action }}-{{ scope }}="{{ targetId }}">
        <div class="wk-icon wk-button__icon">{% include icon_name %}</div>
        <span class="wk-button__label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-button-mobile",
    data: "product",
    events: {
      "click button[data-wk-add-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        const variantInput = document.querySelector("form *[name='id']");
        const variantId = variantInput ? variantInput.value : undefined;

        WishlistKing.toolkit.addProduct(
          event.currentTarget.getAttribute("data-wk-add-product"),
          variantId
        );
      },
      "click button[data-wk-remove-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeProduct(
          event.currentTarget.getAttribute("data-wk-remove-product")
        );
      },
      "click button[data-wk-remove-item]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeItem(
          event.currentTarget.getAttribute("data-wk-remove-item")
        );
      },
    },
    template: `
      {% if product.in_wishlist %}
        {% assign btn_text = locale.in_wishlist %}
        {% assign btn_title = locale.remove_from_wishlist %}
        {% assign btn_action = 'remove' %}
      {% else %}
        {% assign btn_text = locale.add_to_wishlist %}
        {% assign btn_title = locale.add_to_wishlist %}
        {% assign btn_action = 'add' %}
      {% endif %}
      {% assign scope = "product" %}
      {% assign targetId = product.id %}
      {% assign icon_name = "wishlist-iconMobile" %}
      {% if itemId %}
      {% assign scope = "item" %}
      {% assign targetId = itemId %}
      {% assign icon_name = "remove-iconMobile" %}
      {% endif %}
      <button type="button" class="wk-button wk-button--{{ btn_action }} {{ addClass }}" title="{{ btn_title }}" data-wk-{{ btn_action }}-{{ scope }}="{{ targetId }}">
        <div class="wk-icon wk-button__icon">{% include icon_name %}</div>
        <span class="wk-button__label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-button-remove",
    data: "product",
    events: {
      "click button[data-wk-add-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        const variantInput = document.querySelector("form *[name='id']");
        const variantId = variantInput ? variantInput.value : undefined;

        WishlistKing.toolkit.addProduct(
          event.currentTarget.getAttribute("data-wk-add-product"),
          variantId
        );
      },
      "click button[data-wk-remove-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeProduct(
          event.currentTarget.getAttribute("data-wk-remove-product")
        );
      },
      "click button[data-wk-remove-item]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeItem(
          event.currentTarget.getAttribute("data-wk-remove-item")
        );
      },
    },
    template: `
      {% if product.in_wishlist %}
        {% assign btn_text = locale.in_wishlist %}
        {% assign btn_title = locale.remove_from_wishlist %}
        {% assign btn_action = 'remove' %}
      {% else %}
        {% assign btn_text = locale.add_to_wishlist %}
        {% assign btn_title = locale.add_to_wishlist %}
        {% assign btn_action = 'add' %}
      {% endif %}
      {% assign scope = "product" %}
      {% assign targetId = product.id %}
      {% assign icon_name = "wishlist-iconRemove" %}
      {% if itemId %}
      {% assign scope = "item" %}
      {% assign targetId = itemId %}
      {% assign icon_name = "wishlist-iconRemove" %}
      {% endif %}
      <button type="button" class="wk-button wk-button--{{ btn_action }} {{ addClass }}" title="{{ btn_title }}" data-wk-{{ btn_action }}-{{ scope }}="{{ targetId }}">
        <div class="wk-icon wk-button__icon">{% include icon_name %}</div>
        <span class="wk-button__label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-button-custom",
    data: "product",
    events: {
      "click button[data-wk-add-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        const variantInput = document.querySelector("form *[name='id']");
        const variantId = variantInput ? variantInput.value : undefined;

        WishlistKing.toolkit.addProduct(
          event.currentTarget.getAttribute("data-wk-add-product"),
          variantId
        );

        window.currentWishlistedProduct = event.currentTarget.getAttribute("data-wk-add-product")
      },
      "click button[data-wk-remove-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeProduct(
          event.currentTarget.getAttribute("data-wk-remove-product")
        );

        window.currentWishlistedProduct = event.currentTarget.getAttribute("data-wk-remove-product")
      },
      "click button[data-wk-remove-item]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeItem(
          event.currentTarget.getAttribute("data-wk-remove-item")
        );
      },
    },
    template: `
      {% if product.in_wishlist %}
        {% assign btn_text = locale.in_wishlist %}
        {% assign btn_title = locale.remove_from_wishlist %}
        {% assign btn_action = 'remove' %}
      {% else %}
        {% assign btn_text = locale.add_to_wishlist %}
        {% assign btn_title = locale.add_to_wishlist %}
        {% assign btn_action = 'add' %}
      {% endif %}

      {% assign scope = "product" %}
      {% assign targetId = product.id %}
      {% assign icon_name = "wishlist-icon" %}

      {% if itemId %}
      {% assign scope = "item" %}
      {% assign targetId = itemId %}
      {% assign icon_name = "remove-icon" %}
      {% endif %}

      <button type="button" class="wk-button wk-button--{{ btn_action }} {{ addClass }}" title="{{ btn_title }}" data-wk-{{ btn_action }}-{{ scope }}="{{ targetId }}">
        <div class="wk-icon wk-button__icon">{% if btn_action == 'remove' %}{% include icon_name %}{% else %}{% include 'remove-icon' %}{% endif %}</div>
        <span class="wk-button__label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-button-floating",
    data: "product",
    template: `
      {% include "wishlist-button" addClass: "wk-button--floating" %}
    `,
  },
  {
    id: "wishlist-button-mobile-floating",
    data: "product",
    template: `
      {% include "wishlist-button-mobile" addClass: "wk-button--floating__mobile" %}
    `,
  },
  {
    id: "wishlist-button-remove-floating",
    data: "product",
    template: `
      {% include "wishlist-button-remove" addClass: "wk-button--floating" %}
    `,
  },
  {
    id: "wishlist-page",
    data: "wishlist",
    events: {
      "click a[data-wk-share]": (event) => {
        event.preventDefault();
        event.stopPropagation();
        WishlistKing.toolkit.requestWishlistSharing({
          wkShareService: event.currentTarget.getAttribute(
            "data-wk-share-service"
          ),
          wkShare: event.currentTarget.getAttribute("data-wk-share"),
          wkShareImage: event.currentTarget.getAttribute("data-wk-share-image"),
        });
      },
    },
    template: `
      <div class='wk-page {% if wishlist.read_only %}wk-page--shared{% endif %}'>
      {% if wishlist.item_count == 0 %}

          <div class="wk-note wk-note__list-empty u-pad-t-l">
            <p>{{ locale.wishlist_empty_note }}</p>
          </div>

      {% else %}

        {% if customer_accounts_enabled and customer == null and wishlist.read_only == false %}
          <div class="wk-note wk-note__login u-pad-t-l u-pad-l-m u-pad-r-m">
            <p class="u-marg-b-m">{{ locale.save_wishlist }}</p>
            <div class="u-flex justify-content-center align-items-center gap-m">
              <a href="/account/login" class="button button--primary button--m u-decoration-none">{{ locale.login }}</a>
            </div>
          </div>
        {% endif %}

        <div>
          <div 
            class="wk-grid u-pad-t-m u-marg-lr-auto gap-xl"
            {% if wishlist.item_count < 4 %}
              style="grid-template-columns: repeat({{wishlist.item_count}}, 1fr); {% if wishlist.item_count == 1 %}max-width: 206.5px;{% elsif wishlist.item_count == 2 %}max-width: 441px;{% elsif wishlist.item_count == 3 %}max-width: 676px;{% endif %}"
            {% endif %}
          >
            {% assign item_count = 0 %}
            {% assign products = wishlist.products | reverse %}
            {% for product in products %}
              {% assign item_count = item_count | plus: 1 %}
              {% unless limit and item_count > limit %}
                {% assign hide_default_title = false %}
                {% if product.variants.length == 1 and product.variants[0].title contains 'Default' %}
                  {% assign hide_default_title = true %}
                {% endif %}

                {% assign variant = product.selected_or_first_available_variant %}
                {% if variant.price < variant.compare_at_price %}
                  {% assign onsale = true %}
                {% else %}
                  {% assign onsale = false %}
                {% endif %}
                <div class="wk-grid__item-wrapper">
                  <div class="wk-grid__item {% if onsale %}wk-product--sale{% endif %}" data-wk-item="{{ product.wishlist_item_id }}">
                    <div>
                      {% unless wishlist.read_only %}
                        {% include "wishlist-button-remove-floating" itemId: product.wishlist_item_id %}
                      {% else %}
                        {% include "wishlist-button-remove-floating" product: product %}
                      {% endunless %}

                      <a href="{{ product | variant_url }}" class="wk-product-image" title="{{ locale.view_product }}" style="background-image: url({{ product | variant_img_url: '1000x' }})"></a>
                    </div>

                    <div class="wk-product-info-wrapper u-flex flex-column justify-content-between u-full-height u-full-width">
                      <div class="wk-product-info u-marg-t-m u-marg-b-m">
                        <a class="wk-product-title" href="{{ product | variant_url }}">
                          {{ product.title }}
                        </a>
                        {% assign target = product.selected_or_first_available_variant %}
                        {% assign compare_at_price = target.compare_at_price %}
                        {% assign price = target.price | default: 1999 %}
                        {% assign money_price = price | money %}
                        {% assign discount = compare_at_price | minus: price | times:100 | divided_by:compare_at_price | prepend: '-' | append: '%' | strip %}
                        {% if settings.currency_code_enabled %}
                          {% assign money_price = price | money_with_currency %}
                        {% endif %}
                        <div class="wk-product-price u-marg-t-s">
                          <span class="wk-product-price--current">{{ variant.price | money }}</span>
                          <span class="wk-product-price--compare u-marg-l-s u-philippine-gray">{{ variant.compare_at_price | money }}</span>
                          {% if compare_at_price > price %}
                            <span class="price-item price-item--discount u-marg-l-s">{{ discount }}</span>
                          {% endif %}
                        </div>
                      </div>

                      {% include "wishlist-product-form-custom" %}
                    </div>
                  </div>
                </div>
              {% endunless %}
            {% endfor %}
          </div>
        </div>

        {% comment %}
        {% include "wishlist-button-bulk-add-to-cart" %}
        {% endcomment %}

        {% comment %}
        {% unless wishlist.read_only %}
          {% include "wishlist-button-clear" %}
        {% endunless %}
        {% endcomment %}

        {% unless wishlist.read_only %}
          <div class="wk-sharing u-none">
            <h4 class="wk-title">{{ locale.share_wishlist }}</h4>
            <ul class="wk-sharing__list">
              <li class="wk-sharing__list-item">{% include "wishlist-share-button-fb" %}</li>
              <li class="wk-sharing__list-item">{% include "wishlist-share-button-twitter" %}</li>
              <li class="wk-sharing__list-item">{% include "wishlist-share-button-email" %}</li>
              <li class="wk-sharing__list-item">{% include "wishlist-share-button-link" %}</li>
              <li class="wk-sharing__list-item">{% include "wishlist-share-button-whatsapp" %}</li>
              {% comment %}<li class="wk-sharing__list-item">{% include "wishlist-share-button-contact" %}</li>{% endcomment %}
            </ul>
            <div class="wk-sharing__link wk-sharing__link--hidden"><span class="wk-sharing__link-text"></span><button class="wk-sharing__link__copy-button" data-clipboard-target=".wk-sharing__link-text">{{ locale.copy_share_link }}</button></div>
          </div>
        {% endunless %}
      {% endif %}
      </div>
    `,
  },
  {
    id: "wishlist-product-form",
    events: {
      "render .wk-product-form": (form) => {
        const container = form.closest("[data-wk-item]");
        const itemId = container.getAttribute("data-wk-item");
        WishlistKing.toolkit.getItem(itemId).then((product) => {
          WishlistKing.toolkit.initProductForm(form, product, {
            // NOTE: Uncomment to override default option change
            // onOptionChange: (event) => {
            //   console.log(event.dataset);
            // },
            // NOTE: Uncomment to override default form submit
            // onFormSubmit: (event) => {
            //   event.preventDefault();
            //   event.stopPropagation();
            // },
          });
        });
      },
    },
    template: `
      <form class="wk-product-form" action="/cart/add" method="post">
        {% assign current_variant = product.selected_or_first_available_variant %}
        <div class="wk-product-form__options">
          <input name="id" value="{{ current_variant.id }}" type="hidden">
          {% unless product.has_only_default_variant %}
            {% for option in product.options_with_values %}
              <div class="wk-product-form__option">
                <label class="wk-product-form__option__label" for="Option{{ option.position }}">
                  {{ option.name }}
                </label>
                <select class="wk-product-form__option__select" name="options[{{ option.name | escape }}]">
                  {% for value in option.values %}
                    <option value="{{ value | escape }}" {% if option.selected_value == value %}selected="selected"{% endif %} {% if option.soldout_values contains value %}disabled{% endif %}>
                      {{ value }}
                    </option>
                  {% endfor %}
                </select>
              </div>
            {% endfor %}
          {% endunless %}
          {% comment %}
          <div class="wk-product-form__quantity">
            <label class="wk-product-form__quantity__label" for="Quantity">{{ locale.quantity }}</label>
            <input class="wk-product-form__quantity__input" type="number" name="quantity" value="1" min="1">
          </div>
          {% endcomment %}
        </div>
        <button type="submit" class="wk-product-form__submit" data-wk-add-to-cart="{{ product.wishlist_item_id }}" {% unless current_variant.available %}disabled{% endunless %}>
          {% if current_variant.available %}{{ locale.add_to_cart }}{% else %}{{ locale.sold_out }}{% endif %}
        </button>
      </form>
    `,
  },
  {
    id: "wishlist-product-form-custom",
    events: {
      "render .wk-product-form-custom": async (form) => {
        const select = form.querySelector('.js-product-size-select')
        const inputId = form.querySelector('input[name="id"]')
        const addToCartButton = form.querySelector("#product-add-to-cart")
        select.addEventListener('change', (e) => {
          inputId.value = e.target.value
        })

        const handle = form.dataset.productHandle
        const url = `/products/${handle}?view=data`;
        const response = await fetch(url);
        const productData = response.status === 200 && !response.redirected ? await response.json() : undefined
        for(const variant of productData.variants) {
          const option = form.querySelector(`#variant-${variant.id}`)
          if(variant.available == false) {
            option.disabled = "true"
            option.innerHTML = `${variant.title} - ${window.variantStrings.unavailable}`
          }
        }

        const selectedVariant = select.querySelector('option[selected="selected"]')
        const variantDataAvailability = productData.variants.find(x => x.id === Number(selectedVariant.id.split('variant-')[1])).available
        if(!variantDataAvailability) {
          addToCartButton.setAttribute('disabled', 'true')
          addToCartButton.textContent = window.variantStrings.unavailable
        }

        select.addEventListener('change', (e) => {
          const variantDataAvailability = productData.variants.find(x => x.id === Number(e.target.value)).available
          if(!variantDataAvailability) {
            addToCartButton.setAttribute('disabled', 'true')
            addToCartButton.textContent = window.variantStrings.unavailable
          } else {
            addToCartButton.removeAttribute('disabled', 'false')
            addToCartButton.textContent = window.variantStrings.addToCart
          }
        })
      }
    },
    template: `
      <product-form class="product-form wk-product-form-custom u-marg-t-auto" data-product-handle={{ product.handle }}>
        <div class="product-form__error-message-wrapper u-marg-b-m" role="alert" hidden>
          <span class="product-form__error-message text--regular u-error"></span>
        </div>
        <form
          method="post"
          action="/cart/add"
          accept-charset="UTF-8"
          class="form u-flex flex-column gap-m"
          enctype="multipart/form-data"
          novalidate="novalidate"
          data-type="add-to-cart-form"
        >
          {% assign current_variant = product.selected_or_first_available_variant %}
          <input name="id" value="{{ current_variant.id }}" type="hidden">
          {% unless product.has_only_default_variant %}
            {% assign productVariantsLength = product.variants.length %}
            {% unless productVariantsLength == 1 %}
              {% for option in product.options_with_values %}
                <div class="wk-product-form__option u-relative">
                  <label class="wk-product-form__option__label" for="Option{{ option.position }}">
                    {{ option.name }}
                  </label>
                  <select class="wk-product-form__option__select | js-product-size-select" name="options[{{ option.name | escape }}]">
                    {% for variant in product.variants %}
                      <option id="variant-{{ variant.id }}" value="{{ variant.id }}" {% if option.selected_value == variant.title %}selected="selected"{% endif %} {% if variant.available == false %}disabled{% endif %}>
                        {% if variant.available == false %}
                          {{ variant.title }} - {{ locale.sold_out }}
                        {% else %}
                          {{ variant.title }}
                        {% endif %}
                      </option>
                    {% endfor %}
                  </select>
                </div>
              {% endfor %}
              {% endunless %}
          {% endunless %}
          <button
            type="submit"
            name="add"
            id="product-add-to-cart"
            class="wk-product-form__submit"
            {% unless current_variant.available %}disabled{% endunless %}
          >
            {% if current_variant.available %}{{ locale.add_to_cart }}{% else %}{{ locale.sold_out }}{% endif %}
          </button>
        </form>
      </product-form>
    `,
  },
  {
    id: "wishlist-page-shared",
    data: "shared_wishlist",
    template: `
      {% assign wishlist = shared_wishlist %}
      {% include "wishlist-page" with wishlist %}
    `,
  },
  {
    id: "wishlist-button-bulk-add-to-cart",
    data: "wishlist",
    events: {
      "click button[data-wk-bulk-add-to-cart]": (event) => {
        WishlistKing.toolkit.requestAddAllToCart(
          event.currentTarget.getAttribute("data-wk-bulk-add-to-cart")
        );
      },
    },
    template: `
      {% assign btn_text = locale.add_all_to_cart %}
      {% assign btn_title = locale.add_all_to_cart %}

      <button type="button" class="wk-button-bulk-add-to-cart" title="{{ btn_title }}" data-wk-bulk-add-to-cart="{{ wishlist.permaId }}">
        <span class="wk-label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-button-clear",
    data: "wishlist",
    events: {
      "click button[data-wk-clear-wishlist]": (event) => {
        WishlistKing.toolkit.clear(
          event.currentTarget.getAttribute("data-wk-clear-wishlist")
        );
      },
    },
    template: `
      {% assign btn_text = locale.clear_wishlist %}
      {% assign btn_title = locale.clear_wishlist %}

      <button type="button" class="wk-button-wishlist-clear" title="{{ btn_title }}" data-wk-clear-wishlist="{{ wishlist.permaId }}">
        <span class="wk-label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-icon",
    template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" fill="none"><path stroke="#292525" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333" d="M21.69 3.298a4.511 4.511 0 0 0-6.327 0l-.863.854-.862-.854A4.496 4.496 0 0 0 10.474 2 4.497 4.497 0 0 0 7.31 3.298 4.408 4.408 0 0 0 6 6.431c0 1.174.471 2.301 1.31 3.132l.862.854 6.328 6.265 6.327-6.265.862-.854a4.392 4.392 0 0 0 0-6.265v0Z"/></svg>
    `,
  },
  {
    id: "wishlist-iconRemove",
    template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none"><path stroke="#292525" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.83" d="M9 1 1 9m0-8 8 8"/></svg>    `,
  },
  {
    id: "remove-icon",
    template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" fill="none"><path fill="#292525" stroke="#292525" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333" d="M21.69 3.298a4.511 4.511 0 0 0-6.327 0l-.863.854-.862-.854A4.496 4.496 0 0 0 10.474 2 4.497 4.497 0 0 0 7.31 3.298 4.408 4.408 0 0 0 6 6.431c0 1.174.471 2.301 1.31 3.132l.862.854 6.328 6.265 6.327-6.265.862-.854a4.392 4.392 0 0 0 0-6.265v0Z"/></svg>    
    `,
  },
  {
    id: "wishlist-iconMobile",
    template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" fill="none"><path stroke="#292525" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333" d="M12.998 1.972a3.427 3.427 0 0 0-1.11-.72 3.512 3.512 0 0 0-2.619 0 3.428 3.428 0 0 0-1.11.72l-.66.64-.658-.64A3.475 3.475 0 0 0 4.42 1c-.907 0-1.777.35-2.419.972A3.27 3.27 0 0 0 1 4.32c0 .88.36 1.725 1.002 2.347L7.5 12l5.498-5.334c.317-.308.57-.674.742-1.076a3.234 3.234 0 0 0 0-2.54 3.312 3.312 0 0 0-.742-1.078Z"/></svg>    `,
  },
  {
    id: "remove-iconMobile",
    template: `

    445 bytes → 307 bytes 68.99%
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" fill="none"><path fill="#292525" stroke="#292525" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333" d="M12.998 1.972a3.427 3.427 0 0 0-1.11-.72 3.512 3.512 0 0 0-2.619 0 3.428 3.428 0 0 0-1.11.72l-.66.64-.658-.64A3.475 3.475 0 0 0 4.42 1c-.907 0-1.777.35-2.419.972A3.27 3.27 0 0 0 1 4.32c0 .88.36 1.725 1.002 2.347L7.5 12l5.498-5.334c.317-.308.57-.674.742-1.076a3.234 3.234 0 0 0 0-2.54 3.312 3.312 0 0 0-.742-1.078Z"/></svg>    `,
  },
  {
    id: "wishlist-icon-custom",
    template: `
      <lottie-player src="https://assets8.lottiefiles.com/packages/lf20_6z3m9mpw.json" background="transparent"  speed="1" autoplay></lottie-player>
    `,
  },
  {
    id: "remove-icon-custom",
    template: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.6 22.9" xml:space="preserve"><path d="M17.8 1.5c-2 0-3.8.9-5 2.5-1.2-1.5-3.1-2.5-5-2.5-3.6 0-6.5 3-6.5 6.7 0 2.2 1 3.7 1.9 5 2.4 3.6 8.6 8.1 8.8 8.3.5.4 1.2.4 1.7 0 .3-.2 6.4-4.7 8.8-8.3.8-1.2 1.9-2.8 1.9-5-.1-3.7-3-6.7-6.6-6.7z" fill="none" stroke="#eb1f4a" stroke-miterlimit="10"/></svg>
    `,
  },
  {
    id: "wishlist-share-button-fb",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_on_facebook }}" data-wk-share-service="facebook" data-wk-share="{{ wishlist.permaId }}">
        <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24">
          <path fill="currentColor" d="M18.768,7.465H14.5V5.56c0-0.896,0.594-1.105,1.012-1.105s2.988,0,2.988,0V0.513L14.171,0.5C10.244,0.5,9.5,3.438,9.5,5.32 v2.145h-3v4h3c0,5.212,0,12,0,12h5c0,0,0-6.85,0-12h3.851L18.768,7.465z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-twitter",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_on_twitter }}" data-wk-share-service="twitter" data-wk-share="{{ wishlist.permaId }}">
        <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24">
        <path fill="currentColor" d="M23.444,4.834c-0.814,0.363-1.5,0.375-2.228,0.016c0.938-0.562,0.981-0.957,1.32-2.019c-0.878,0.521-1.851,0.9-2.886,1.104 C18.823,3.053,17.642,2.5,16.335,2.5c-2.51,0-4.544,2.036-4.544,4.544c0,0.356,0.04,0.703,0.117,1.036 C8.132,7.891,4.783,6.082,2.542,3.332C2.151,4.003,1.927,4.784,1.927,5.617c0,1.577,0.803,2.967,2.021,3.782 C3.203,9.375,2.503,9.171,1.891,8.831C1.89,8.85,1.89,8.868,1.89,8.888c0,2.202,1.566,4.038,3.646,4.456 c-0.666,0.181-1.368,0.209-2.053,0.079c0.579,1.804,2.257,3.118,4.245,3.155C5.783,18.102,3.372,18.737,1,18.459 C3.012,19.748,5.399,20.5,7.966,20.5c8.358,0,12.928-6.924,12.928-12.929c0-0.198-0.003-0.393-0.012-0.588 C21.769,6.343,22.835,5.746,23.444,4.834z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-whatsapp",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_with_whatsapp }}" data-wk-share-service="whatsapp" data-wk-share="{{ wishlist.permaId }}">
        <svg xmlns="https://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24">
          <path fill="currentColor" stroke="none" d="M20.1,3.9C17.9,1.7,15,0.5,12,0.5C5.8,0.5,0.7,5.6,0.7,11.9c0,2,0.5,3.9,1.5,5.6l-1.6,5.9l6-1.6c1.6,0.9,3.5,1.3,5.4,1.3l0,0l0,0c6.3,0,11.4-5.1,11.4-11.4C23.3,8.9,22.2,6,20.1,3.9z M12,21.4L12,21.4c-1.7,0-3.3-0.5-4.8-1.3l-0.4-0.2l-3.5,1l1-3.4L4,17c-1-1.5-1.4-3.2-1.4-5.1c0-5.2,4.2-9.4,9.4-9.4c2.5,0,4.9,1,6.7,2.8c1.8,1.8,2.8,4.2,2.8,6.7C21.4,17.2,17.2,21.4,12,21.4z M17.1,14.3c-0.3-0.1-1.7-0.9-1.9-1c-0.3-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.8,1-0.9,1.1c-0.2,0.2-0.3,0.2-0.6,0.1c-0.3-0.1-1.2-0.5-2.3-1.4c-0.9-0.8-1.4-1.7-1.6-2c-0.2-0.3,0-0.5,0.1-0.6s0.3-0.3,0.4-0.5c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0-0.4,0-0.5c0-0.1-0.7-1.5-1-2.1C8.9,6.6,8.6,6.7,8.5,6.7c-0.2,0-0.4,0-0.6,0S7.5,6.8,7.2,7c-0.3,0.3-1,1-1,2.4s1,2.8,1.1,3c0.1,0.2,2,3.1,4.9,4.3c0.7,0.3,1.2,0.5,1.6,0.6c0.7,0.2,1.3,0.2,1.8,0.1c0.6-0.1,1.7-0.7,1.9-1.3c0.2-0.7,0.2-1.2,0.2-1.3C17.6,14.5,17.4,14.4,17.1,14.3z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-email",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_by_email }}" data-wk-share-service="email" data-wk-share="{{ wishlist.permaId }}">
        <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24"">
          <path fill="currentColor" d="M22,4H2C0.897,4,0,4.897,0,6v12c0,1.103,0.897,2,2,2h20c1.103,0,2-0.897,2-2V6C24,4.897,23.103,4,22,4z M7.248,14.434 l-3.5,2C3.67,16.479,3.584,16.5,3.5,16.5c-0.174,0-0.342-0.09-0.435-0.252c-0.137-0.239-0.054-0.545,0.186-0.682l3.5-2 c0.24-0.137,0.545-0.054,0.682,0.186C7.571,13.992,7.488,14.297,7.248,14.434z M12,14.5c-0.094,0-0.189-0.026-0.271-0.08l-8.5-5.5 C2.997,8.77,2.93,8.46,3.081,8.229c0.15-0.23,0.459-0.298,0.691-0.147L12,13.405l8.229-5.324c0.232-0.15,0.542-0.084,0.691,0.147 c0.15,0.232,0.083,0.542-0.148,0.691l-8.5,5.5C12.189,14.474,12.095,14.5,12,14.5z M20.934,16.248 C20.842,16.41,20.673,16.5,20.5,16.5c-0.084,0-0.169-0.021-0.248-0.065l-3.5-2c-0.24-0.137-0.323-0.442-0.186-0.682 s0.443-0.322,0.682-0.186l3.5,2C20.988,15.703,21.071,16.009,20.934,16.248z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-link",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.get_link }}" data-wk-share-service="link" data-wk-share="{{ wishlist.permaId }}">
        <svg xmlns='https://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 512 512'>
          <path fill="currentColor" d='M459.654,233.373l-90.531,90.5c-49.969,50-131.031,50-181,0c-7.875-7.844-14.031-16.688-19.438-25.813
            l42.063-42.063c2-2.016,4.469-3.172,6.828-4.531c2.906,9.938,7.984,19.344,15.797,27.156c24.953,24.969,65.563,24.938,90.5,0
            l90.5-90.5c24.969-24.969,24.969-65.563,0-90.516c-24.938-24.953-65.531-24.953-90.5,0l-32.188,32.219
            c-26.109-10.172-54.25-12.906-81.641-8.891l68.578-68.578c50-49.984,131.031-49.984,181.031,0
            C509.623,102.342,509.623,183.389,459.654,233.373z M220.326,382.186l-32.203,32.219c-24.953,24.938-65.563,24.938-90.516,0
            c-24.953-24.969-24.953-65.563,0-90.531l90.516-90.5c24.969-24.969,65.547-24.969,90.5,0c7.797,7.797,12.875,17.203,15.813,27.125
            c2.375-1.375,4.813-2.5,6.813-4.5l42.063-42.047c-5.375-9.156-11.563-17.969-19.438-25.828c-49.969-49.984-131.031-49.984-181.016,0
            l-90.5,90.5c-49.984,50-49.984,131.031,0,181.031c49.984,49.969,131.031,49.969,181.016,0l68.594-68.594
            C274.561,395.092,246.42,392.342,220.326,382.186z'/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-contact",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.send_to_customer_service }}" data-wk-share-service="contact" data-wk-share="{{ wishlist.permaId }}">
        <svg width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
        </svg>
      </a>
    `,
  },
];

export default templates;
